export const CONTACT_PERSONS_TABLE_UNIQUE_ID = 'contact-persons';

export const CONTACT_PERSONS_TABLE_ROW_HEIGHT = 48;

/**
 * Initial width of every column of the contact persons table, keyed by the same `col-*` class
 * the header and row cells in contact-persons-table.html carry.
 *
 * Keep in sync with contact-persons-table.scss.
 */
export const CONTACT_PERSONS_TABLE_COLUMN_WIDTHS: { [key: string]: number } = {
  'col-branch': 180,
  'col-phone': 150,
  'col-email': 220,
  'col-role': 140,
  'col-sms': 110,
  'col-email-notifications': 110,
  'col-actions': 48
};
